// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2oIGB","head":"Table_head__3mdrB","col":"Table_col__iDKEo"};